/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Product } from './Product.js';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product.js';

/**
 * 
 * @export
 * @interface ProductRecommendation
 */
export interface ProductRecommendation {
    /**
     * 
     * @type {number}
     * @memberof ProductRecommendation
     */
    contactId?: number;
    /**
     * 
     * @type {Array<Product>}
     * @memberof ProductRecommendation
     */
    products?: Array<Product>;
    /**
     * 
     * @type {string}
     * @memberof ProductRecommendation
     */
    errorMessage?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProductRecommendation
     */
    dateCreated?: Date;
}

/**
 * Check if a given object implements the ProductRecommendation interface.
 */
export function instanceOfProductRecommendation(value: object): boolean {
    return true;
}

export function ProductRecommendationFromJSON(json: any): ProductRecommendation {
    return ProductRecommendationFromJSONTyped(json, false);
}

export function ProductRecommendationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductRecommendation {
    if (json == null) {
        return json;
    }
    return {
        
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'products': json['products'] == null ? undefined : ((json['products'] as Array<any>).map(ProductFromJSON)),
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
    };
}

export function ProductRecommendationToJSON(value?: ProductRecommendation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contactId': value['contactId'],
        'products': value['products'] == null ? undefined : ((value['products'] as Array<any>).map(ProductToJSON)),
        'errorMessage': value['errorMessage'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
    };
}

